import script from "./DetailLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./DetailLayout.vue?vue&type=script&lang=ts&setup=true"

import "./DetailLayout.vue?vue&type=style&index=0&id=3f32ed12&lang=scss&scoped=true"

import exportComponent from "/Users/mac/work/aem/weixin-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f32ed12"]])

export default __exports__